import { StatsPageProps } from './stats.types';

export const StatsPagePresets: Partial<StatsPageProps> = {};
